import React, { useState } from "react"
import Layout from "../../../components/layouts"
import Banner from "../../../components/features/Banner"
import SEO from "../../../components/common/SEO"
import ReactWOW from "react-wow"
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query SafetyMeetings {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: "Safety Meetings",
    subtitle: `Safety Meetings are an essential addition to your organization’s safety toolbox. They provide an opportunity to answer questions, address any hazards on a worksite, and discuss the proper ways to execute procedures. It’s also a great time to review unsafe habits or behaviors, take corrective action, and talk about what to do to in case of injuries, accidents or emergencies.`,
    featureName: "safetymeetings",
    rightButtonText: "Why Certificate Tracking Software?",
    rightButtonSrc: "https://www.youtube.com/watch?v=xE2yXvWB038",
    mockupImg: '/features/safety-meetings/feature-header-safetymeetings.png'
  }

  const seo = {
    title: "Workhub | Free Safety Meetings Software Toolbox Talks Safety Culture",
    description: "Our Safety Meetings tool makes it easy to schedule safety meetings, toolbox talks, send notifications & track & record attendance so that you can identify risks & promote safety culture in the workplace.",
    image: "/features/safety-meetings/social-card.jpg",
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Paper trail",
      para: "Create a digital paper trail of what is discussed at safety meetings and who was in attendance.",
    },
    {
      title: "Meeting Types",
      para: "Develop meeting types to serve as templates for meeting creation. Choose whether they are not applicable, optional, or mandatory.",
    },

    {
      title: "Supporting Documents",
      para: "Link any relevant procedures, inspections, hazards, and action items to help support the discussion.",
    },

    {
      title: "Set up",
      para: "Workers create meetings from meeting types and select dates, times, attendees, and can leave preliminary notes.",
    },
    {
      title: "Review",
      para: "An administrator can review the meeting (if specified) and approve. ",
    },
    {
      title: "Missed Meetings",
      para: "Missed meetings show up on the worker dashboard and meeting minutes will show up in the “Required” tab.",
    },
  ]


  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">
        <section className="feature-section">
          <div className="container">
            <div className="row switch-children">
              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="/features/safety-meetings/safety-meeting-cartoon3.jpg"
                    alt="Safety Meeting Cartoon"
                  />
                </ReactWOW>
              </div>

              <div className="col-lg-6 feature-text">
                <h2>
                  Combating Complacency
                </h2>
                <p>
                  Meeting regularly to discuss rules and guidelines helps keep workers safe. One of the biggest benefits of safety meetings is that they help combat complacency. It’s easy for workers to become complacent when they do a particular task or job often, making a workplace less safe. Offering a frequent reminder of workplace procedures and the need for safety is the best way to combat those moments.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="feature-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 feature-text">
                <h2>Create meeting templates</h2>
                <p>
                  Our Safety Meetings component allows you to create a whole host of safety meeting type templates. These templates can be used by facilitators on your team to host, record, and submit meeting information each time a meeting of that type is held. When creating a meeting type template, an admin can include a default agenda to be followed, the option to link to specific procedures, incidents or hazards, inspections, or action items, choose possible facilitators, and assign the meeting type to its relevant locations. Settings also allow you to outline who needs to acknowledge a meeting, whether they missed it in-person or not. These templates allow your team to swiftly and easily host a safety meeting anywhere.
                </p>
              </div>

              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInRight" delay="0.9s">
                  <img
                    className="feature-img-left"
                    src="/features/safety-meetings/sketch-mockup-safety-meetings-admin-1.png"
                    alt="Safety Meeting Admin Computer View"
                  />
                </ReactWOW>
              </div>
            </div>
          </div>
        </section>

        <section className="feature-section">
          <div className="container">
            <div className="row switch-children">
              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="/features/safety-meetings/sketch-mockup-safety-meetings-admin-2.png"
                    alt="Safety Meeting Admin Computer View"
                  />
                </ReactWOW>
              </div>

              <div className="col-lg-6 feature-text">
                <h2>
                  Schedule and facilitate your meetings
                </h2>

                <p>
                  After creating your meeting templates, the folks you’ve chosen as facilitators can schedule meetings. After setting day and time for a particular meeting, they can include any information for it, invite the relevant workers from various locations, and attach any related items, such as any procedures reviewed or incidents discussed. Facilitators don’t need to be administrators in your organization, so as long as you’ve entrusted them to host a meeting, they can do so from the office, a tailgate, or in the field.
                </p>

                <p>
                  After a meeting has been held and all the details are included, facilitators can submit the meeting for admin review.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="feature-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 feature-text">
                <h2>
                  Workers can access meetings from anywhere
                </h2>

                <p>
                  Your workers can now access safety meetings from any location, from the office to locations in the field. They can review any and all details for safety meetings they are invited to, mark themselves as having attended a meeting, and depending on settings, acknowledge meeting contents as well. Meetings are accessible on desktops, laptops, tablets, and phones, so workers are never caught without access and facilitators can host wherever they are! 
                </p>

                <p>
                  The dash tile for Safety Meetings will notify workers if there are upcoming meetings they’re invited to attend, or if meetings need their acknowledgement after the fact. Facilitators will receive additional notifications if the meetings they need to host are past due.
                </p>
              </div>

              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-left"
                    src="/features/safety-meetings/sketch-mockup-safety-meetings-worker-1.png"
                    alt="Safety Meeting Worker Tablet View"
                  />
                </ReactWOW>
              </div>
            </div>
          </div>
        </section>

        <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>


      </main>
    </Layout>
  )
}
